import { render, staticRenderFns } from "./SofortIdentCallback.vue?vue&type=template&id=1bebea0d&scoped=true&"
import script from "./SofortIdentCallback.vue?vue&type=script&lang=ts&"
export * from "./SofortIdentCallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bebea0d",
  null
  
)

export default component.exports